import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './OdinCheckbox.scss';

/* for the love of god make sure the input ID is unique. Even if it isn't being rendered. */

class OdinCheckbox extends Component {
  constructor(props) {
    super(props);
  }
  checkClick = () => {
    // click by the icon
    if (this.props.hasOwnProperty('onChange')) this.props.onChange();
  }
  changeHandler = (event) => {
    // clicked by the label
    if (this.props.hasOwnProperty('onChange')) this.props.onChange();
  }
  render() {
    return (
      <span className={"d-inline-block mr-1 " + styles.ocbSpan}>
        {this.props.checkType == 'round' ? <img onClick={this.checkClick} src={'/assets/images/' + (this.props.checked ? 'checked_round_blue.png' : 'unchecked_round_blue.png')} className={styles.ocbLarge} width="18" height="17" alt={this.props.checked ? 'checked' : 'unchecked'} />
          : <img onClick={this.checkClick} src={'/assets/images/' + (this.props.checked ? 'Checked.png' : 'Unchecked.png')} className={styles.ocb} width="18" height="17" alt={this.props.checked ? 'checked' : 'unchecked'} />
        }
        <input
          className='d-none'
          type="checkbox"
          id={this.props.id}
          name={this.props.id}
          checked={this.props.checked}
          onChange={this.changeHandler}
        />
      </span>
    );
  }
}

OdinCheckbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  checkType: PropTypes.string,
};

export default OdinCheckbox;
